import { ILabelItemInput } from '@hts/shared/types';
import { useCallback } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';
import styles from '../../styles/CategoryOfCard/CategoryCard.module.scss';
import { ICardListItemState } from '../../types';

interface ICategoryCardProps {
  card: ICardListItemState;
}

export const CategoryCard: React.FC<ICategoryCardProps> = ({ card }) => {
  const { id, name, categories, price, cardDetails, labels } = card;

  const src = cardDetails?.fileUrlThumbnail || cardDetails?.fileUrl || '';

  const renderLabel = useCallback(
    (label: ILabelItemInput, index: number) => (
      <span
        key={`${label.id}-${index}`}
        className={`btn ${label.id === 2 ? 'btn-danger' : 'btn-fill'}`}
      >
        {label.name}
      </span>
    ),
    []
  );

  return (
    <Link to={`/card/${id}`} className={`card-preview ${styles.container}`}>
      {Boolean(labels?.length) && (
        <div className="card-preview-tags">{labels.map(renderLabel)}</div>
      )}

      <span className="img-holder">
        <LazyLoadImage
          src={src}
          alt={name}
          effect="blur"
          loading="lazy"
          className={styles.image}
          wrapperClassName={styles.imageWrapper}
        />
      </span>

      <span className="list-item-descr">
        <span className="list-item-name-holder">
          {categories?.length > 0 && <h3>{categories.at(0)?.name}</h3>}

          <strong>{name}</strong>
        </span>

        <span className="price">
          <span className="woocommerce-Price-amount amount">
            {price ? (
              <>
                <span className="woocommerce-Price-currencySymbol">&#36;</span>

                {price}
              </>
            ) : (
              'Free'
            )}
          </span>
        </span>
      </span>
    </Link>
  );
};
